var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import PropTypes from 'prop-types';
import RcSelect, { Option, OptGroup } from 'rc-select';
import classNames from 'classnames';
import LocaleReceiver from '../locale-provider/LocaleReceiver';
import defaultLocale from '../locale-provider/default';
const SelectPropTypes = {
    prefixCls: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.oneOf(['default', 'large', 'small']),
    combobox: PropTypes.bool,
    notFoundContent: PropTypes.any,
    showSearch: PropTypes.bool,
    optionLabelProp: PropTypes.string,
    transitionName: PropTypes.string,
    choiceTransitionName: PropTypes.string,
};
// => It is needless to export the declaration of below two inner components.
// export { Option, OptGroup };
export default class Select extends React.Component {
    constructor(props) {
        super(props);
        this.focus = () => {
            if (this.selectRef.current) {
                this.selectRef.current.focus();
            }
        };
        this.blur = () => {
            if (this.selectRef.current) {
                this.selectRef.current.blur();
            }
        };
        this.renderSelect = (locale) => {
            const _a = this.props, { prefixCls, direction, className = '', size, mode, listHeight = 256, listItemHeight = 24, virtual = false, getPopupContainer, dropdownClassName, filterOption = true } = _a, restProps = __rest(_a, ["prefixCls", "direction", "className", "size", "mode", "listHeight", "listItemHeight", "virtual", "getPopupContainer", "dropdownClassName", "filterOption"]);
            const cls = classNames({
                [`${prefixCls}-lg`]: size === 'large',
                [`${prefixCls}-sm`]: size === 'small',
            }, className);
            let { notFoundContent, optionLabelProp } = this.props;
            const isCombobox = mode === 'combobox';
            if (isCombobox) {
                // children 带 dom 结构时，无法填入输入框
                optionLabelProp = optionLabelProp || 'value';
            }
            const modeConfig = {
                multiple: mode === 'multiple',
                tags: mode === 'tags',
                combobox: true,
            };
            // AutoComplete don't have notFoundContent defaultly
            const notFoundContentLocale = notFoundContent || locale.notFoundContent;
            const rcSelectRtlDropDownClassName = classNames(dropdownClassName);
            return (<RcSelect {...restProps} {...modeConfig} virtual={virtual} mode={mode} listHeight={listHeight} listItemHeight={listItemHeight} prefixCls={prefixCls} direction={direction} className={cls} optionLabelProp={optionLabelProp || 'children'} notFoundContent={notFoundContentLocale} getPopupContainer={getPopupContainer} ref={this.selectRef} dropdownClassName={rcSelectRtlDropDownClassName} filterOption={filterOption}/>);
        };
        this.selectRef = React.createRef();
    }
    render() {
        return (<LocaleReceiver componentName="Select" defaultLocale={defaultLocale.Select}>
        {this.renderSelect}
      </LocaleReceiver>);
    }
}
Select.Option = Option;
Select.OptGroup = OptGroup;
Select.defaultProps = {
    prefixCls: 'wmstool-select',
    showSearch: false,
    transitionName: 'slide-up',
    choiceTransitionName: 'zoom',
};
Select.propTypes = SelectPropTypes;



// WEBPACK FOOTER //
// ./components/select/index.tsx